import router from "next/router";
import MetaSeo from '../MetaSeo';
export default function why() {
  return (
    <>
      <MetaSeo />
      <div id='main-content'>
        <div className='page-why'>
          <div className='container'>
            <div className='sc-why'>
              <div className='box-flex'>
                <div className='box-text'>
                  <h1 className='txt-title' >
                    Tại sao bạn nên <br />ứng tuyển ngay <br />vào TCOM ?
                  </h1>
                  <div className='list-why'>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/save-money.svg' alt='Save Money' />
                      </div>
                      <div className='text-why h-425'>
                        Lương hấp dẫn so với thị trường, <br />được review 2 lần 1 năm
                      </div>
                      <div className='text-why s-425'>
                        Lương hấp dẫn so với <br />thị trường, được review <br />2 lần 1 năm
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/enviroment.svg' alt='Enviroment' />
                      </div>
                      <div className='text-why'>
                        Môi trường tốt để phát triển <br />bản thân và sự nghiệp
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/Reward.svg' alt='Reward' />
                      </div>
                      <div className='text-why h-425'>
                        Thưởng theo dự án, thưởng OKRs, <br />xứng đáng với những đóng góp <br />và sự nỗ lực của bạn
                      </div>
                      <div className='text-why s-425'>
                        Thưởng theo dự án, thưởng <br />OKRs, xứng đáng với đóng <br />góp và sự nỗ lực của bạn
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/Opportunity.svg' alt='Capacity' />
                      </div>
                      <div className='text-why'>
                        Luôn có những bài toán <br />công nghệ lớn, thử thách <br />năng lực bạn liên tục
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/Regime.svg' alt='Participation' />
                      </div>
                      <div className='text-why h-425'>
                        Tham gia vào các dự án quy mô <br />quốc tế, tiếp xúc với những quy <br />trình và con người chuyên nghiệp, <br />công nghệ mới
                      </div>
                      <div className='text-why s-425'>
                        Tham gia vào các dự án quy <br />mô quốc tế, tiếp xúc với <br />những quy trình và con người <br />chuyên nghiệp,công nghệ mới
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/participation.svg' alt='Regime' />
                      </div>
                      <div className='text-why'>
                        Chế độ đãi ngộ chung <br />đầy đủ, hấp dẫn, theo <br />pháp luật quy định
                      </div>
                    </div>
                    <div className='box-why'>
                      <div className='icon-why'>
                        <img src='/assets/images/why/capacity.svg' alt='Opportunity' />
                      </div>
                      <div className='text-why'>
                        Có nhiều cơ hội đi Nhật
                      </div>
                    </div>
                  </div>
                </div>
                <div className='box-img'>
                  <img src='/assets/images/why/img-whytcom.svg' alt='Why Tcom' />
                </div>
              </div>
            </div>
            <div className='sc-recruitment'>
              <h1>Cơ hội nghề nghiệp</h1>
              <div className='txt-text why-text1'>
                <span>
                  <p><q>❝  TCOM luôn tìm kiếm những con người đam mê thử thách <br />để tạo nên những giá trị tuyệt vời nhất.<br />
                    Hãy trở thành một phần của gia đình TCOM ngay hôm nay. ❞ </q></p>
                </span>

                {/* <p>TCOM luôn tìm kiếm những con người đam mê thử thách <br />để tạo nên những giá trị tuyệt vời nhất.</p>
              <p>Hãy trở thành một phần của gia đình TCOM ngay hôm nay</p> */}
              </div>
              <div className='txt-text why-text2'>
                <span>
                  <p>TCOM luôn tìm kiếm những con người đam mê thử thách <br />để tạo nên những giá trị tuyệt vời nhất.</p>
                  <p>Hãy trở thành một phần của gia đình <br />TCOM ngay hôm nay.</p>
                </span>
              </div>
              <a onClick={() => router.push('/jobs')} id='showpopup' className='bt-apply'>
                <p>
                  Ứng tuyển ngay
                </p>
              </a>
            </div>
          </div>
          <div className='form-application' id='form-popup'>
            <div id='overlay' />
            <div className='popup-container'>
              <div className='popup-header'>
                <div className='logo'>
                  <a href='/'>
                    <img src='/assets/images/logo_nb.svg' alt='TCOM' />
                  </a>
                </div>
                <div className='close-popup' id='closeBtn'>
                  <a href='#'>
                    <img src='/assets/images/detail/bi_x.svg' alt='close' />
                  </a>
                </div>
              </div>
              <div className='popup-content'>
                <div className='ttl'>Form ứng tuyển</div>
                <form>
                  <div className='form-group'>
                    <label htmlFor='f-name'>Họ và tên:</label>
                    <input type='text' className='form-control' id='f-name' placeholder='Nhập họ và tên' />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='f-phone'>Số điện thoại:</label>
                    <input type='tel' className='form-control' id='f-phone' placeholder='Nhập số điện thoại:' />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='f-mail'>Email:</label>
                    <input type='email' className='form-control' id='f-mail' placeholder='Nhập địa chỉ email:' />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='f-location'>Địa điểm:</label>
                    <select id='f-location' className='form-control'>
                      <option selected>Hà Nội</option>
                      <option>Đà Nẵng</option>
                      <option>Hồ Chí Minh</option>
                    </select>
                  </div>
                  <div className='form-group'>
                    <label htmlFor='f-link'>Link Profile hoặc Porlio</label>
                    <input type='text' className='form-control' id='f-link' placeholder='URL' />
                  </div>
                  <div className='form-upload'>
                    <div className='ttl-upload'>Tải lên các loại tệp DOC, DOCX, PDF (tối đa 5MB) *
                    </div>
                    <div className='drop_box' id='pdrop_box1'>
                      <input type='file' hidden accept='.doc,.docx,.pdf' id='fileID' style={{ display: 'none' }} />
                      <div className='drop-icon'>
                        <a href='#' id='picon-upload1'>
                          <img src='/assets/images/detail/icon-file.svg' alt='icon file' />
                        </a>
                      </div>
                    </div>
                  </div>
                  <button type='submit' className='btn-submit'>Gửi đơn ứng tuyển</button>
                  <button className='btn-slter' id='sendlater'>Gửi sau</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>


  );
}